import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import InventoryEditFormImpl from './InventoryEditFormImpl';
import InventoryList from './InventoryList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import InventoryListView from './InventoryListView'


export default function InventoryDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.inventoryDashboard);
  const [ inventoryId, setInventoryId] = React.useState('');
  const [reloadInventoryList, setReloadInventoryList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <InventoryEditFormImpl 
            setReloadInventoryList={setReloadInventoryList}
            inventoryId={inventoryId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <InventoryListView 
                      setInventoryId = {setInventoryId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
